const VALUES = [
  "Qualität",
  "Vertrauen",
  "Regionalität",
  "Transparenz",
  "Professionalität",
  "Verantwortung",
  "Nachhaltigkeit",
];

export default function Values() {
  return (
    <section
      id="ueber-uns"
      data-testid="values-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="max-w-5xl mx-auto px-5 md:px-8 lg:px-12 text-center">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0A3B2C] mb-4">
          Über uns
        </div>
        <h2
          className="text-3xl md:text-5xl font-bold tracking-tight leading-[1.1] text-[#0A3B2C] mb-6"
          style={{ fontFamily: "Outfit, sans-serif" }}
          data-testid="values-title"
        >
          Werte, die uns führen.
        </h2>
        <p className="text-base md:text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto mb-12">
          Sieben Prinzipien, die jede Kampagne, jedes Gespräch und jede
          Zusammenarbeit prägen.
        </p>

        <div className="flex flex-wrap gap-3 md:gap-4 justify-center">
          {VALUES.map((v, i) => (
            <div
              key={v}
              data-testid={`value-tag-${i}`}
              className="group relative px-6 py-3 rounded-full border border-[#0A3B2C]/20 hover:border-[#0A3B2C] bg-white hover:bg-[#0A3B2C] transition-all cursor-default"
            >
              <span className="text-sm md:text-base font-semibold text-[#0A3B2C] group-hover:text-white transition-colors">
                {v}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
